<template>
	<v-row>
		<v-dialog v-model="showDialog" :fullscreen="$vuetify.breakpoint.mobile" scrollable persistent no-click-animation max-width="500px" max-height="90%">
			<v-container class="pa-0">
				<v-layout fill-height>
					<v-card width="100%" height="100%" class="py-8 d-flex flex-column justify-center align-center">
						<v-icon x-large color="#185EA9">cloud_upload</v-icon>
						<h4>{{ $t('wkt.client.expensesheets.reading-ticket-dialog.info') }}</h4>
					</v-card>
				</v-layout>
			</v-container>
		</v-dialog>
	</v-row>	
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
	name: 'ReadingTicketDialog',
	mixins: [BaseModule],
	components: {
	},
	data () {
		return {
			showDialog: false
		}
	},
	methods: {
        onWheel(event) {
            event.stopPropagation();
        },
		open() {
			this.showDialog = true;
		},
        close() {
            this.showDialog = false;
        },
	},
}
</script>